import {
  EVENT_NAME,
  EventProps,
  trackAnalyticsEvent,
} from '@leagueplatform/analytics';
import {
  GDSStyleObject,
  Icon,
  queryHelpers,
  TextAction,
  useMediaQuery,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { useHistoryGoBack } from 'hooks/use-history-go-back.hook';

export const BackButtonArrow = ({
  fallbackPath,
  css,
  analyticsEventProps,
}: {
  fallbackPath?: string;
  css?: GDSStyleObject;
  analyticsEventProps?: EventProps;
}) => {
  const { goBack } = useHistoryGoBack(fallbackPath);
  const isMobile = useMediaQuery(queryHelpers.down('laptop'));
  const { formatMessage } = useIntl();

  const handleClick = () => {
    trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      detail: 'back arrow button',
      ...analyticsEventProps,
    });
    goBack();
  };

  return (
    <TextAction
      onClick={handleClick}
      as="button"
      css={{
        color: '$onSurfaceIconPrimary',
        ...css,
      }}
    >
      <Icon
        icon={isMobile ? 'interfaceChevronLeft' : 'interfaceArrowLeft'}
        label={formatMessage({ id: 'GO_BACK' })}
      />
    </TextAction>
  );
};
